<template>
    <div class="body" v-show="visible">
        <div class="modal">
            <!-- loading -->
            <div v-if="loading" class="modal-loading">
                <div class="spinner"></div>
            </div>
            <template v-else>
                <div style="flex: 1">
                    <h4 v-if="!isMessage">{{ title }}</h4>
                    <p v-if="!isMessage">{{ subtitle }}</p>
                    <p v-else>{{ message }}</p>
                </div>
                <div class="btnWrap">
                    <span @click="$emit('no')" v-show="!isMessage">
                        <img src="@/assets/images/no.png" alt="" />
                    </span>
                    <span @click="$emit('yes')" v-show="!isMessage">
                        <img src="@/assets/images/yes.png" alt="" />
                    </span>
                    <span @click="$emit('ok')" class="spanOk" v-show="isMessage">
                        <img src="@/assets/images/ok.png" alt="" />
                    </span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        loading: Boolean,
        isMessage: Boolean,
        title: String,
        subtitle: String,
        message: String
    }
}
</script>

<style scoped lang="less">
.body {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.42);
    z-index: 200;
    .modal {
        line-height: 2.25rem;
        width: 80%;
        max-width: 600px;
        aspect-ratio: 998 / 1004;
        border-radius: 1.125rem;
        box-shadow: 0 0.5rem 3.375rem 0 #6e8eb8;
        padding: 4.9375rem 2.25rem 1.625rem;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: url('~@/assets/images/modal.png') no-repeat center top;
        background-size: 100% auto;
        h4 {
            color: #227bfe;
            font-size: 3rem;
            margin-bottom: 2.5rem;
        }
        p {
            font-size: 1.8rem;
            color: #fff;
            padding: 0 1.5rem;
        }
        .modal-loading {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            .spinner {
                width: 2.5rem;
                height: 2.5rem;
                border: 4px solid rgba(255, 255, 255, 0.3);
                border-top-color: #fff;
                border-radius: 50%;
                animation: spin 0.8s linear infinite;
            }
        }
        .btnWrap {
            display: flex;
            justify-content: space-between;
            .spanOk {
                margin: 0 auto;
            }
            span {
                display: inline-block;
                width: 45%;
                padding: 3rem 0;
                cursor: pointer;
                img {
                    width: 100%;
                }
            }
        }
    }
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
